import { render } from "./RoomMessage.vue?vue&type=template&id=e8d66694&scoped=true"
import script from "./RoomMessage.vue?vue&type=script&lang=js"
export * from "./RoomMessage.vue?vue&type=script&lang=js"

import "./RoomMessage.vue?vue&type=style&index=0&id=e8d66694&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d66694"]])

export default __exports__